"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var header_1 = require("../constants/header");
var tailwind_1 = require("../constants/tailwind");
var accordion_1 = require("../modules/accordion");
var get_element_1 = require("../utils/get_element");
/**
 * 要素を非表示にするヘルパー
 */
var hide = function (el) { return el === null || el === void 0 ? void 0 : el.classList.add(tailwind_1.TAILWIND_CLASSES.HIDDEN); };
/**
 * 要素を表示するヘルパー
 */
var show = function (el) { return el === null || el === void 0 ? void 0 : el.classList.remove(tailwind_1.TAILWIND_CLASSES.HIDDEN); };
/**
 * クラスの付け外しを制御するヘルパー
 */
var toggleClass = function (el, className, force) { return el.classList.toggle(className, force); };
/**
 * ハンバーガーメニューの開閉イベントを初期化
 */
var initHamburgerEvent = function () {
    var hamburgerButton = (0, get_element_1.getElementById)(header_1.HEADER_IDS.HAMBURGER_BUTTON);
    var hamburgerOpenIcon = (0, get_element_1.getElementById)(header_1.HEADER_IDS.HAMBURGER_OPEN_ICON);
    var hamburgerCloseIcon = (0, get_element_1.getElementById)(header_1.HEADER_IDS.HAMBURGER_CLOSE_ICON);
    var hamburgerContent = (0, get_element_1.getElementById)(header_1.HEADER_IDS.HAMBURGER_CONTENT);
    var mainContent = document.querySelector('.ec-layoutRole__main');
    var bottomContent = document.querySelector('.ec-layoutRole__contentBottom');
    var footerContent = document.querySelector('.ec-layoutRole__footer');
    hamburgerButton.addEventListener('click', function () {
        // 次の状態（開く or 閉じる）を判定
        var willOpen = !hamburgerButton.classList.contains(tailwind_1.TAILWIND_CLASSES.OPEN);
        // ボタンの状態を更新
        toggleClass(hamburgerButton, tailwind_1.TAILWIND_CLASSES.OPEN, willOpen);
        // アイコンの切り替え（開くアイコン / 閉じるアイコン）
        toggleClass(hamburgerOpenIcon, tailwind_1.TAILWIND_CLASSES.HIDDEN, willOpen);
        toggleClass(hamburgerCloseIcon, tailwind_1.TAILWIND_CLASSES.HIDDEN, !willOpen);
        // ハンバーガーメニュー内容の表示切り替え
        toggleClass(hamburgerContent, tailwind_1.TAILWIND_CLASSES.HIDDEN, !willOpen);
        // メインコンテンツの表示切り替え（メニュー開時は非表示）
        var pageElements = [mainContent, bottomContent, footerContent];
        pageElements.forEach(function (el) { return (willOpen ? hide(el) : show(el)); });
    });
};
/**
 * ハンバーガーメニュー内のアコーディオンを初期化
 */
var initHamburgerMenuAccordion = function () {
    var container = (0, get_element_1.getElementById)(header_1.HEADER_IDS.HAMBURGER_CONTAINER);
    new accordion_1.Accordion(container);
};
// 初期化処理
initHamburgerEvent();
initHamburgerMenuAccordion();
